module.exports = __webpack_public_path__ + "static/media/DashboardGrey.cfcd5d52.svg";